import { dcopy } from '~/utils/utils'

export default {
  computed: {
    getPageFaq () {
      const FAQs = dcopy(this.$store.state?.page?.page?.faq?.raw || [])
      return FAQs?.map((item) => {
        const exists = item.values.filter(i => i.question && i.answer)
        let current = exists ? exists.find(i => i.language.shortcode === this.$store.getters['lang/locale']) : null
        if (!current && exists) {
          current = exists[0]
        }
        if (!current) {
          return
        }

        const $store = this.boat

        const rTemplate = {
          boat_name: $store?.id
            ? `${$store?.brand?.name} ${$store?.model} - ${$store?.name}`
            : this.$t('faq_boat-name')
        }

        for (const [key, value] of Object.entries(rTemplate)) {
          const reg = new RegExp(`%${key}%`, 'g')
          current.question = current.question.replace(reg, value)
          current.answer = current.answer.replace(reg, value)
        }

        return current
      })
    }
  }
}
